<template>
    <div v-if="!shop_user" class="no_orders">
        <img src="../assets/images/no_order.png" />
	    <div>啊喔~没有订单</div> 
        <div class="go-shop" @click="goShop">去商城 > </div>
    </div>
    <div class="myOrders" v-else>
        <mt-navbar v-model="orderStatus" fixed >
            <!-- 订单状态(1.全部订单，2.待付款，3.待发货，4.待收货，5.退款/售后) -->
            <mt-tab-item id="1">全部</mt-tab-item>
            <mt-tab-item id="2">待付款</mt-tab-item>
            <mt-tab-item id="3">待发货</mt-tab-item>
            <mt-tab-item id="4">待收货</mt-tab-item>
            <!-- <mt-tab-item id="5">售后</mt-tab-item> -->
        </mt-navbar>
        <div v-if="orders==''" class="no_orders">
            <img src="../assets/images/no_order.png" />
            <div>啊喔~没有订单</div> 
            <div class="go-shop" @click="goShop">去商城 > </div>
        </div>
        <mt-tab-container v-model="orderStatus" v-else>
            <mt-tab-container-item :id="orderStatus">
                <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="40">
                    <div class="store-content" v-for="item in orders" :key="item.id">
                        <div :data-order-id="item.order_id"  @click="openOrderDetail($event,item.order_id)">
                            <div class="store-title">
                                <span class="store-name">{{item.products[0].merchant_name}}</span>
                                <span class="order-statue" v-if="item.order_status=='initial'">待付款</span>
                                <span class="order-statue" v-if="item.order_status=='paid'">待发货</span>
                                <span class="order-statue" v-if="item.order_status=='deliver'">待收货</span>
                                <span class="order-statue" v-if="item.order_status=='delivered'">已收货</span>
                                <span class="order-statue" v-if="item.order_status=='canceled'">订单已取消</span>
                            </div>
                            <!-- <mt-cell v-for="product in item.products" :key="product.id" :label="product.spec" :title="product.title">
                                <span class="normal-price" v-if="product.price==product.vip_price">￥{{product.price}}</span>
                                <span v-else>
                                    <span class="vip-price" >￥{{product.vip_price}}</span>
                                    <span class="original-price">￥{{product.price}}</span>
                                </span>
                                <span class="amount">x{{product.amount}}</span>
                                <img slot="icon" :src="product.cover_image" @click="openProduct($event)" :data-product-id="product.product_id">
                            </mt-cell> -->
                            <div  v-for="product in item.products" :key="product.id" style="display:flex" class="product_list">
                                <div class="left">
                                    <img slot="icon" :src="product.cover_image" @click="openProduct($event)" :data-product-id="product.product_id">
                                </div>
                                <div class="right">
                                    <div class="top">
                                        <span class="title">{{product.title}}</span>
                                        <span class="normal-price" v-if="product.price==product.vip_price">￥{{product.price}}</span>
                                        <span v-else style="text-align:right;float:right">
                                            <span class="vip-price" >￥{{product.vip_price}}</span>
                                            <span class="original-price">￥{{product.price}}</span>
                                        </span>
                                    </div>
                                    <div class="bottom">
                                        <span class="spec">{{product.spec}}</span>
                                        <span class="amount">x{{product.amount}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="total-info">
                            <span>共{{item.total_num}}件商品</span>
                            <span>总计：￥<span class="big-price">{{item.vip_total_price.split('.')[0]}}</span>.{{item.vip_total_price.split('.')[1]}}（含运费 ￥{{item.express_price}})</span>
                        </div>
                        <div class="operate-btns">
                            <!-- (initial.待付款，paid.待发货， deliver.待收货，delivered.已收货) -->
                            <mt-button type="default" v-if="item.order_status!=='paid'&&item.order_status!=='deliver'" :data-order-no="item.order_no" @click="delOrder($event)">删除订单</mt-button>
                            <mt-button type="default" v-if="item.order_status=='deliver'||item.order_status=='delivered'" @click="expressInfo($event)" :data-order-id="item.order_id">查看物流</mt-button>
                            <!-- <mt-button type="default" v-if="item.order_status=='deliver'" :data-order-no="item.order_no">确认收货</mt-button> -->
                            <!-- 再次购买跳转至订单第一个商品 -->
                            <mt-button type="default"  :data-product-id="item.products[0].product_id" @click="openProduct($event)">再次购买</mt-button>
                            <mt-button type="default" v-if="item.order_status=='initial'" :data-order-no="item.order_no" @click="cancelOrder($event)">取消订单</mt-button>
                            <mt-button type="default" v-if="item.order_status=='initial'" :data-order-id="item.order_id" @click="pay($event)">去支付</mt-button>
                        </div>
                    </div>
                </div>
                <!--显示加载中状态-->
                <div class="loading-box" v-if="loading">
                    <mt-spinner type="triple-bounce" class="loading-more"  color="#D7AD81"></mt-spinner>	                   		                  
                </div>
                <div class="no-more" v-if="noMore" >没有更多数据了</div> 	 
            </mt-tab-container-item>
        </mt-tab-container>
    </div>
</template>
<script>
import {setData} from '../util/setData.js'
export default {
  name: 'myOrders',
  data () {
    return {
        orderStatus:'1',
        current_page:1,//当前页
        per_page:6,//每页个数
        total_pages:null,//总页数
        loading: false, // 加载中转圈
        shop_user:false, //商城用户不存在
        noMore: false, // 是否还有更多
        orders:null,
        // platform_user_id:'9cc769a0-3369-11e9-8717-0242ac110029',
        product:{
            product_id:{}
        },
    }
  },
  created:function(){
        this.urltext()
        this.showOrders(this.orderStatus)
  },
  mounted:function(){
        // window.getPlatformUserId = this.getPlatformUserId();
        // this.showOrders(this.orderStatus)
        // this.urltext()
        // this.showOrders(this.orderStatus)
  },
  methods:{
    urltext() {
        let loc = location.href; 
        let n1 = loc.length;//地址的总长度
        let n2 = loc.indexOf("=");//取得=号的位置
        let outToken = loc.substr(n2 + 1, n1 - n2);//从=号后面的内容
        console.log(outToken)
        if(outToken==loc){
        this.platform_user_id = ''
        }else{
            this.platform_user_id = outToken
        }
    },
    // getPlatformUserId(params) {
    //     //params: 原生调用Vue时传值（params）给Vue
    //     // alert('dfdjfkdfjdk')
    //     alert("得到原生传值结果:" + params);
    //     this.platform_user_id = params;
    // },
    showOrders(orderStatus){
        let that = this
        this.loading = true;
        this.noMore = false;
        let datas= {
            platform_user_id:that.platform_user_id,
            status:that.orderStatus,
            page:that.current_page,
            per_page:that.per_page
        }
        let datas_new = setData(datas)//数据加密
        that.$axios.get("order/list",{
            params:datas_new
        })
        .then((res)=>{
            console.log(res)
            if(res.status == '200'){ 
                if(res.data.status_code=='200'){
                    // console.log(res.data.data)
                    if (that.current_page === 1) {
                        that.orders = res.data.data.orders;	
				    } else {      
                        that.orders = that.orders.concat(res.data.data.orders);		  
                    } 
                    that.shop_user = true //商城用户存在
                    that.current_page= res.data.data.page
                    that.total_pages = res.data.data.total_pages; //总页数	                                            
		            that.loading = false;
              }else{
                 that.shop_user = false //商城用户不存在
              }
            }
        })
        .catch(function(err){
            console.log(err);
            return false;
        })
    },
    openOrderDetail(e,order_id){
        console.log(order_id)
        // this.$router.push('/orderDetail/'+platform_user_id+'/'+order_id)
        this.$router.push({path:'/orderDetail/',params:{order_id:order_id,platform_user_id:this.platform_user_id},query:{order_id:order_id,platform_user_id:this.platform_user_id}})
    },
    loadMore(){
        this.current_page += 1 // 增加分页
        this.loading = true // 加载中
        if(this.current_page <= this.total_pages){
			//加载数据
			setTimeout(()=>{
				this.showOrders(this.orderStatus)
			},1000)
		}else{ 
            if(this.orders.length>4){
                this.noMore = true // 显示没有更多了
            }
			this.loading = false // 关闭加载中
			return false
		}
    },
    // 取消订单
    cancelOrder(e){
        let that=this
        console.log(e.target.getAttribute('data-order-no'))
        that.$messagebox({
            title: '提示',
            message: '确定取消订单吗?',
            showCancelButton: true
        })
        .then(action=>{
            if (action == 'confirm') {
                let order_no=e.target.getAttribute('data-order-no')
                let datas= {
                    platform_user_id:that.platform_user_id,
                    order_no:order_no
                }
                let datas_new = setData(datas)//数据加密
                console.log(datas_new)
                that.$axios({
                    method:'post',
                    url:'order/cancel',
                    data:datas_new,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                .then((res)=>{
                    console.log(res)
                    if(res.data.status_code == '200'){
                        that.current_page=1
                        that.showOrders(that.current_page)
                    }
                })
            }
            
        }) 
        .catch(err => { 
            if (err == 'cancel') {     //取消的回调
                console.log(2);
            }
        })
    },
    //删除订单
    delOrder(e){
        let that=this
        console.log(e.target.getAttribute('data-order-no'))
        that.$messagebox({
            title: '提示',
            message: '确定删除订单吗?',
            showCancelButton: true
        })
        .then(action=>{
            if (action == 'confirm') { 
                let order_no=e.target.getAttribute('data-order-no')
                let datas= {
                    platform_user_id:that.platform_user_id,
                    order_no:order_no
                }
                let datas_new = setData(datas)//数据加密
                console.log(datas_new)
                that.$axios({
                    method:'post',
                    url:'order/delete',
                    data:datas_new,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                .then((res)=>{
                    console.log(res)
                    if(res.data.status_code == '200'){
                        that.current_page=1
                        that.showOrders(that.current_page)
                    }
                })
            }
            
        }) 
        .catch(err => { 
            if (err == 'cancel') {     //取消的回调
                console.log(2);
            }
        })
    },
    //查看物流
    expressInfo(e){
        let that=this
        console.log(e.target.getAttribute('data-order-id'))
        let order_id=e.target.getAttribute('data-order-id')
        let datas= {
            platform_user_id:that.platform_user_id,
            order_id:order_id
        }
        let datas_new = setData(datas)//数据加密
        console.log(datas_new)
        that.$axios.get("order/express",{
            params:datas_new
        })
        .then((res)=>{
            console.log(res)
            if(res.data.status_code == '200'){
                let com= res.data.data.com
                let sn= res.data.data.sn
                window.open('http://www.baidu.com'); 
                // window.open('http://www.kuaidi100.com/chaxun?com=' + com + '&nu=' + sn); 
            }
        }) 

    },
    //打开商品详情
    openProduct(e){
        window.event? window.event.cancelBubble = true : e.stopPropagation();
        // console.log(e.target.getAttribute('data-product-id'))
        let product_id=e.target.getAttribute('data-product-id')
        console.log(product_id)
        console.log(typeof(product_id))
        // window.webkit.messageHandlers.buyAgain.postMessage({
        //     product_id: product_id, //vue给iOS传值
        // });   
        let ua= navigator.userAgent
        let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1; 
        let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
        if(isAndroid){
            if(order){
                order.buyAgain(product_id) //vue给android传值; 
            }
        }else if(isiOS){
            window.webkit.messageHandlers.buyAgain.postMessage({
                product_id: product_id, //vue给iOS传值
            });
        }
    },
    //去支付
    pay(e){
        console.log(e.target.getAttribute('data-order-id'))
        let order_id=e.target.getAttribute('data-order-id')   
        // alert('order_id')
        // order.buyAgain({
        //     order_id: order_id, //vue给android传值
        // }); 
        // window.webkit.messageHandlers.payAgain.postMessage({
        //     order_id: order_id, //vue给iOS传值
        // });   
        let ua= navigator.userAgent
        let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1; 
        let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
        if(isAndroid){
            if(order){
                order.payAgain({
                    order_id: order_id, //vue给android传值
                }); 
            }
        }else if(isiOS){
            window.webkit.messageHandlers.payAgain.postMessage({
                order_id: order_id, //vue给iOS传值
            });
        }
    },
    // 去小程序商城
    goShop(){
        let ua= navigator.userAgent
        let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1; 
        let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
        if(isAndroid){
            if(order){
                order.goShop() //vue给android传值; 
            }
        }else if(isiOS){
            window.webkit.messageHandlers.goShop.postMessage({
                // product_id: product_id, //vue给iOS传值
            });
        }
    }
  },
  watch: {
    orderStatus: function (val, oldVal) {
        // 这里就可以通过 val 的值变更来确定
        // console.log(oldVal)
        // console.log(val)
        
        this.current_page=1;
        console.log(this.current_page)
        this.showOrders(val)
    }
}
}
</script>
<style lang="scss" scoped="" type="text/css">
    .no_orders{
        text-align:center;
        padding-top:45%;
        color:#333;
        font-size:15px;
        img{
            width:35%;
            margin-bottom:10px;
        }
        .go-shop{
            margin-top:10px;
            color:#fff;
            background-color:#D7AD81;
            display:inline-block;
            font-size:15px;
            border-radius:4px;
            padding:4px 18px;
        }
    }
    .mint-navbar{
        border-bottom:1px solid #eee;
        margin:0 10px;
        .mint-tab-item{
            color:#333;
            &.is-selected{
                color:#D7AD81;
                border-color:#D7AD81;
                margin-bottom:-2px;
            }  
        }
    }
    .mint-tab-container{
        margin-top:50px;
        .loading-box{
            text-align:center;
            .loading-more{
                display:block;
                margin:20px auto;
            }     
        }
        .no-more{
            text-align:center;
            margin: 20px auto;
            color:#666;
        }
    }
    
</style>



// WEBPACK FOOTER //
// src/components/myOrders.vue